import { InfoIcon, Table } from '@allurion/ui';
import { toLocalizedDateTime, formatMoney } from '@allurion/utils';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { TrackedEmptyState, TrackedPageHeader } from 'src/analytics/TrackedUI';
import { Seo } from 'src/components/Seo';
import { useAppNavigate } from 'src/hooks/useAppNavigate';
import { useClinicOrders } from 'src/hooks/useClinicOrders';
import { useLocale } from 'src/hooks/useLocale';

import { Container, InnerContainer } from '../../shared-page-elements';

import messages from './clinic-orders.messages';

export function ClinicOrdersPage() {
  const { locale } = useLocale();
  const intl = useIntl();
  const { clinicId } = useParams();
  const { toCreateBalloonOrder } = useAppNavigate();
  const { orders } = useClinicOrders(clinicId!);

  return (
    <>
      <Seo title="Balloon Orders" />
      <TrackedPageHeader
        title={intl.formatMessage(messages.ordersTitle)}
        button={{
          label: intl.formatMessage(messages.newOrderTitle),
          onClick() {
            toCreateBalloonOrder(clinicId!);
          },
          trackLabel: 'create-clinic-order-btn',
        }}
      />
      <Container>
        <InnerContainer>
          {orders.length === 0 ? (
            <TrackedEmptyState
              title={intl.formatMessage(messages.emptyStateTitle)}
              subtitle={intl.formatMessage(messages.emptyStateSubtitle)}
              icon={<InfoIcon />}
              trackedLabel="clinic-orders-empty-state"
            />
          ) : (
            <Table
              columns={[
                {
                  field: 'id',
                  title: intl.formatMessage(messages.orderIdColumn),
                },
                {
                  field: 'externalReference',
                  title: intl.formatMessage(messages.externalReferenceColumn),
                },
                {
                  field: 'items',
                  title: 'Summary',
                  formatter: (_, { items }) =>
                    `${items.reduce((acc, item) => {
                      const { description, quantity } = item;

                      return `${acc}${description} (${quantity})\n`;
                    }, '')}`,
                },

                // {
                //   //@ts-expect-error
                //   field: 'orderedByProvider',
                //   title: 'Ordered By',
                // },
                {
                  field: 'createdAt',
                  title: 'Requested on',
                  formatter: (_, { createdAt }) => {
                    return toLocalizedDateTime(createdAt, locale);
                  },
                },
                // {
                //   //@ts-expect-error
                //   field: 'deliveryDate',
                //   title: 'Completed at',
                // },
                {
                  field: 'status',
                  title: intl.formatMessage(messages.statusColumn),
                },
                {
                  field: 'totalPrice',
                  title: intl.formatMessage(messages.totalPriceColumn),
                  formatter: (_, { totalPrice, currencyCode }) => {
                    return formatMoney(totalPrice, currencyCode, locale);
                  },
                },
                // {
                //   field: 'id',
                //   title: intl.formatMessage(messages.actionsColumn),
                //   //@ts-expect-error
                //   formatter: (id: string) => (
                //     <IconButton
                //       variant="icon"
                //       icon={<InfoIcon />}
                //       onClick={() => {
                //         toBalloonOrderDetailsPage(clinicId!, id);
                //       }}
                //     />
                //   ),
                // },
              ]}
              data={orders}
            />
          )}
        </InnerContainer>
      </Container>
    </>
  );
}
